<template>

    <tq-on-top-container >

        <div slot="body" :id="pb_mapUid_s" :style="{'zIndex': gv_zIndex.tqLeafLet_map}" class="TQ_height_inherit" >
        </div>

        <div slot="bottomRight" class="TQ_margin_8px" v-if="p_showGpsBtn_b && pe_startWatchPosition_f">

            <!-- active location-->
            <tq-card v-if="p_currentUserLocation_c != null" padding="6px 4px 2px 6px"
                     @click.native="m_centerToUserLocation_f"  >
                <img :src="ass_img_myLocation_blue " class="TQ_width_24px TQ_padding_2px"/>
            </tq-card>

            <tq-card padding="6px 4px 2px 6px" v-else-if="nativeApp_b" @click.native="pe_startWatchPosition_f">
                <img :src="ass_img_myLocation_gray" class="TQ_width_24px TQ_padding_2px"/>
            </tq-card>

            <!-- not active -->
            <tq-btn-approve
                    v-else
                    :approve-cb="pe_startWatchPosition_f"
                    :popup-text="ass_strings.question_requestGeoLocation"
                    :system-lang-code="p_display_langCode_e">

                <tq-card padding="6px 4px 2px 6px" class="TQ_clickable" v-if="co_showCompass_b">
                    <img :src="ass_img_myLocation_gray" class="TQ_width_24px TQ_padding_2px"/>
                </tq-card>

            </tq-btn-approve>

        </div>
    </tq-on-top-container>

</template>

<script>

    import L from 'leaflet'
    import 'mapbox-gl-leaflet'

    import { GestureHandling } from "leaflet-gesture-handling";
    import "leaflet/dist/leaflet.css";
    import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

    import {svg_getMarkerFinishHtml_s, svg_getMarkerHtml_s} from "@/scripts/S_Svg";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";
    import {enum_langCodes, enum_mapMissionsTypes, enum_mapTypes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb, validator_null_fb, validator_class_fb, validator_objClass_fb, validator_arrayClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        ass_img_lock_bgRed_w,
        ass_img_myLocation_blue,
        ass_img_myLocation_gray,
        ass_img_unlock_yellow,
        ass_img_checked_green
    } from "@/assets/scripts/Ass_Files";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        obj_forEach_f,
        obj_equals_fb,
        obj_map_fo,
        obj_toArray_fo,
    } from "../../../functions/src/shareCode/Share_S_Obj";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import TqCard from "../basic/TqCard";

    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {
        date_doEveryClockTick_addCb_f,
        date_doEveryClockTick_removeCb_f, date_setTimeout,
    } from "@/scripts/S_Date";
    import {webAppManager_runInNativeApp_fb} from "@/scripts/S_WebAppMediator";
    import {helper_getMapTilerStyle_f} from "@/scripts/S_Helper";
    import {notification_notify2} from "@/scripts/S_Notification";
    import {style_addNewStyle_f} from "@/scripts/S_Style";
    import {
        FB_MapData, FB_MapPoint,
        FB_QuestBody_MissionsGroup
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name: "tqLeafletDisplay",
        components: {TqOnTopContainer, TqCard, TqBtnApprove},
        props:{

            // require values
            pb_mapUid_s : {
                type: String,
                default: "mapid"
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },

            // setting map
            p_mapData_c: {
                type: FB_MapData,
                default () {
                    return new FB_MapData({})
                }
            },

            // paint on map
            p_polygons_ac:{
                type: Array,
                default() {
                    return []
                }
            },
            p_missions_ac:{
                type: Array,
                default() {
                    return []
                }
            },
            p_missionGroups_ac:{
                type: Array,
                default() {return []},
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                }
            },
            p_finishMissionsIndexes_an:{
                type: Array,
                default() {
                    return []
                }
            },
            p_mapMissionType_e:{
                type: String,
                default : enum_mapMissionsTypes.markers,
                validator(val){
                    return validator_enum_fb(enum_mapMissionsTypes, val)
                }
            },

            // players locations
            p_playersLocation_byUserId_c :{
                type: Object,
                validator(obj){
                    return validator_objClass_fb(obj, FB_MapPlayerLocation)
                },
                default(){
                    return {}
                }
            },
            p_currentUserLocation_c:{
                type:FB_MapPlayerLocation,
                validator(val){
                    return validator_null_fb(val) || validator_class_fb(val, FB_MapPlayerLocation)
                }
            },

            // change behavior
            pf_twoFingersMovement_b:{
                type: Boolean,
                default: false
            },
            p_mapType_e:{
                type: String,
                default : enum_mapTypes.osm,
                validator(val){
                    return validator_enum_fb(enum_mapTypes, val)
                }
            },

            p_backgroundImage_s:{
                type: String,
                default: ''
            },
            p_showZoomControl_b:{
                type: Boolean,
                default: true
            },
            p_showGpsBtn_b:{
                type: Boolean,
                default: true
            },
            p_rightZoomBtns_b:{
                type: Boolean,
                default: false
            },

            // functions
            pe_onClickMission_f: {
                type: Function,
                default() {
                    return () => {}
                }
            },
            pe_clickPolygon_f:{
                type: Function,
                default() {
                    return () => {}
                }
            },
            pe_startWatchPosition_f: {
                type: Function,
            },
            pe_stopWatchPosition_f: {
                type: Function,
                default(){
                    return  () => {}
                }
            },
        },
        data(){
            return {
                mymap_l     : null,
                riddles_markers_al : [],
                gv_zIndex   : gv_zIndex,
                holdGeoLocationBtn_b   : false,
                holdThreeSecGeoLocationBtn_b   : false,
                secondsToOldTeamPlayerLocation_n : 30,
                secondsToOldCurrentUserLocation_n : 5,

                displayedRectanglesImagesIndexes_an : [],

                nativeApp_b : webAppManager_runInNativeApp_fb(),

                currentLocation_marker_l    : null,
                playerLocData_byUserId_o : {
                      'userId' : {
                          locationCircle_l : "",
                          accuracyCircle_l : "",
                          name_l : "",
                      }
                },

                polygons_byIndex_l : {},
                overlayImage_byIndex_l : {},
                polygonsMarkers_byIndex_l : {},

                // imports
                ass_img_myLocation_blue : ass_img_myLocation_blue,
                ass_img_myLocation_gray : ass_img_myLocation_gray,
                ass_strings             : ass_strings,

            }
        },
        computed:{
            co_lastOpenRiddleIndex_n(){

                for(let i=0; i < this.p_missions_ac.length; i++){

                    if(!this.m_finishMission_fb(i)){
                        return i
                    }
                }
                return this.p_missions_ac.length
            },
            co_showCompass_b(){
                return [enum_mapTypes.osm].includes(this.p_mapType_e)
            },
            co_missionsIndexes_byRiddleId_c(){
                let missions_byRiddleId_c = {}
                this.p_missions_ac.forEach((qb_mission_c, index_n) => missions_byRiddleId_c[qb_mission_c.qbr_riddleId_n] = index_n)
                return missions_byRiddleId_c
            }
        },
        methods:{

            m_drawMarker_f(index_n, location_c, markerColor_s, text_s){

                // 1) MARKER ICON
                let riddleMarker_l = L.marker(
                    [location_c.mp_lat_n, location_c.mp_lng_n],
                    {
                        icon: L.divIcon({
                            className: "",
                            html: this.p_mapMissionType_e === enum_mapMissionsTypes.markers
                                ? svg_getMarkerHtml_s(markerColor_s)
                                : svg_getMarkerHtml_s(markerColor_s, this.riddles_markers_al.length + 1),
                            iconSize: [38, 95],     // size of the icon
                            iconAnchor  : [19, 40], // point of the icon which will correspond to marker's location
                        }),
                    })
                    .addTo(this.mymap_l)

                // 2) TEXT
                if (text_s != null) {
                    riddleMarker_l.bindPopup(text_s, {offset: L.point(0, -30)})
                }

                // 3) MARKER On Click Event
                riddleMarker_l.on('click', (e) => {
                    this.m_clickMissionWrapper_f(index_n)
                })

                this.riddles_markers_al.push(riddleMarker_l)

            },
            m_drawRectangle_fc(visibleIndex_n, missionIndex_n, position_c, size_c, hide_b) {

                // rectangle numbers
                let marker_l;
                if(!hide_b){
                    marker_l = L.marker(
                        this.m_getLocation_fan(position_c, size_c),
                        {
                            icon: L.divIcon({
                                className: 'TQ_text_24px TQ_leaflet_rectangle_num',   // Set class for CSS styling
                                html: '' + (visibleIndex_n + 1),
                            }),
                        })
                        .addTo(this.mymap_l)
                }


                // Rectangle
                let rectangle_l = L.rectangle(
                    this.m_getBounds_faan(position_c, size_c),
                    {
                        color: "black",
                        weight: 1,
                        opacity : hide_b ? 0 : 1,
                        fillOpacity: 0,

                    }).addTo(this.mymap_l)

                // click number rectangle
                rectangle_l.on('click', (e) => {
                    this.m_clickMissionWrapper_f(missionIndex_n)
                })

                // click number marker
                if(marker_l){
                    marker_l.on('click', (e) => {
                        this.m_clickMissionWrapper_f(missionIndex_n)
                    })
                }

            },
            m_refreshPolygons_f(){

                this.p_polygons_ac.forEach((polygon_c, polygonIndex_n) => {

                    // check if set polygon
                    if(this.polygons_byIndex_l[polygonIndex_n] != null){

                        this.polygons_byIndex_l[polygonIndex_n].setStyle({
                            color       : polygon_c.mdp_color_s,
                            weight      : polygon_c.mdp_strokeWidth_n,
                            fillOpacity : polygon_c.mdp_fillOpacity_n,
                        })

                        if(this.polygonsMarkers_byIndex_l[polygonIndex_n]){
                            this.polygonsMarkers_byIndex_l[polygonIndex_n].setIcon( L.divIcon({
                                className: 'TQ_leaflet_polygon_num ',   // Set class for CSS styling
                                html: polygon_c.mdp_name_s,
                            }))
                        }

                        return
                    }

                    if(polygon_c.mdp_name_s != null){
                        let marker_l = L.marker(
                            this.m_polygonCenter_an(polygon_c.mdp_points_byIndex_c),
                            {
                                icon: L.divIcon({
                                    className: 'TQ_leaflet_polygon_num ',   // Set class for CSS styling
                                    html: polygon_c.mdp_name_s,
                                }),
                            })
                            .addTo(this.mymap_l)

                        marker_l.on('click', (e) => {this.pe_clickPolygon_f(polygonIndex_n)})

                        this.polygonsMarkers_byIndex_l[polygonIndex_n] = marker_l

                    }

                    let polygon_l = L.polygon(
                        obj_toArray_fo(obj_map_fo(polygon_c.mdp_points_byIndex_c, (point_c => {return [point_c.mp_lat_n, point_c.mp_lng_n]}))),
                        {
                            color       : polygon_c.mdp_color_s,
                            weight      : polygon_c.mdp_strokeWidth_n,
                            fillOpacity : polygon_c.mdp_fillOpacity_n,
                        }
                    )

                    polygon_l.addTo(this.mymap_l);

                    polygon_l.on('click', (e) => {this.pe_clickPolygon_f(polygonIndex_n)})

                    this.polygons_byIndex_l[polygonIndex_n] = polygon_l
                })
            },
            m_refreshOverlayImages_f(){

                this.p_mapData_c.md_overlayImages_ac.forEach((md_overlayImage_c, index_n) => {

                    if(this.overlayImage_byIndex_l[index_n] != null){
                        return
                    }

                    let overlayImage_o = this.m_drawImageOnMap_fo({
                        imageUrl_s : md_overlayImage_c.mdoi_imageUrl_s,
                        bounds_ao  : [{lng: md_overlayImage_c.mdoi_northEast_c.mp_lng_n, lat: md_overlayImage_c.mdoi_northEast_c.mp_lat_n}, {lng: md_overlayImage_c.mdoi_southWest_c.mp_lng_n, lat: md_overlayImage_c.mdoi_southWest_c.mp_lat_n}],
                        options_o  : {zIndex: 0 }
                    })

                    this.overlayImage_byIndex_l[index_n] = overlayImage_o

                })
            },
            m_drawImageOnMap_fo({imageUrl_s, bounds_ao, options_o={}, opacity_n=1}){
                let overlayImage = L.imageOverlay(imageUrl_s, bounds_ao, options_o)


                overlayImage.on("load", () => {
                    overlayImage.setOpacity(opacity_n)
                    overlayImage.addTo(this.mymap_l)
                });
                overlayImage._initImage();

                return overlayImage
            },
            m_drawPath_f(startMapPoint_c, endMapPoint_c, pathToNextMission_ac){


                L.polyline([
                        [startMapPoint_c.mp_lat_n, startMapPoint_c.mp_lng_n],
                        ...pathToNextMission_ac.map(mapPoint_c=>{return [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n]}),
                        [endMapPoint_c.mp_lat_n, endMapPoint_c.mp_lng_n]],
                    {})
                    .addTo(this.mymap_l)

            },
            m_refresh_finishMissions_f(){

                this.p_missions_ac.forEach((mission_c, missionIndex_n) => {

                    switch(this.p_mapMissionType_e){

                        case enum_mapMissionsTypes.markers_route:

                            let markerColor_s = missionIndex_n <= this.co_lastOpenRiddleIndex_n ? (missionIndex_n === this.co_lastOpenRiddleIndex_n  ? "#FF8C00" : "#501078") : "gray"

                            this.riddles_markers_al[missionIndex_n].setIcon(L.divIcon({
                                className   : "",
                                html        : svg_getMarkerHtml_s(markerColor_s, missionIndex_n + 1),
                                iconSize    : [38, 95], // size of the icon
                                iconAnchor  : [19, 40], // point of the icon which will correspond to marker's location
                            }))

                            break;
                        case enum_mapMissionsTypes.markers:

                            if(!this.m_finishMission_fb(missionIndex_n)){
                                return
                            }

                            this.riddles_markers_al[missionIndex_n].setIcon(L.divIcon({
                                className   : "",
                                html        : svg_getMarkerFinishHtml_s(mission_c.qbr_theme_c.qbrt_backgroundColor_s),
                                iconSize    : [38, 95], // size of the icon
                                iconAnchor  : [19, 40], // point of the icon which will correspond to marker's location
                            }))

                            break;

                        case enum_mapMissionsTypes.squares_linear_groups_hide:
                        case enum_mapMissionsTypes.squares_linear_groups:
                        case enum_mapMissionsTypes.squares_hide:
                        case enum_mapMissionsTypes.squares_linear:
                            let qb_mission_c = this.p_missions_ac[missionIndex_n]

                            let imgSize_c = new FB_MapPoint({
                                mp_lng_n : qb_mission_c.qbr_rectangleSize_c.mp_lng_n / 1.8,
                                mp_lat_n : qb_mission_c.qbr_rectangleSize_c.mp_lat_n / 1.8,
                            })

                            let position_c = new FB_MapPoint({
                                mp_lng_n : qb_mission_c.qbr_riddlePosition_c.mp_lng_n + (qb_mission_c.qbr_rectangleSize_c.mp_lng_n/2),
                                mp_lat_n : qb_mission_c.qbr_riddlePosition_c.mp_lat_n + (qb_mission_c.qbr_rectangleSize_c.mp_lat_n/2),
                            })

                            if(!this.m_availableSquareRiddle_fb(missionIndex_n)) {

                                this.m_drawImageOnMap_fo({
                                    imageUrl_s : ass_img_lock_bgRed_w,
                                    bounds_ao  : this.m_getBounds_faan(position_c, imgSize_c),
                                })


                            } else if(this.m_finishMission_fb(missionIndex_n)){

                                this.m_drawImageOnMap_fo({
                                    imageUrl_s : ass_img_checked_green,
                                    bounds_ao  : this.m_getBounds_faan(position_c, imgSize_c),
                                })

                            } else{
                                this.m_drawImageOnMap_fo({
                                    imageUrl_s : ass_img_unlock_yellow,
                                    bounds_ao  : this.m_getBounds_faan(position_c, imgSize_c),
                                })
                            }
                            break;

                        case enum_mapMissionsTypes.squares:

                            if(!this.m_finishMission_fb(missionIndex_n)){
                                return
                            }

                            qb_mission_c = this.p_missions_ac[missionIndex_n]

                            // check display svg
                            if(this.displayedRectanglesImagesIndexes_an.includes(missionIndex_n)){return }

                            this.displayedRectanglesImagesIndexes_an.push(missionIndex_n)

                            if (qb_mission_c.qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s == null) {return}

                            this.m_drawImageOnMap_fo({
                                imageUrl_s : qb_mission_c.qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s,
                                bounds_ao  : this.m_getBounds_faan(qb_mission_c.qbr_riddlePosition_c, qb_mission_c.qbr_rectangleSize_c),
                                opacity_n: 0.6,
                            })


                            break;
                    }

                })

            },
            m_refresh_playersLocations_f(){

                obj_forEach_f(
                    this.p_playersLocation_byUserId_c,
                    (mapPlayerLocation_c => {

                        this.m_updatePlayerLocation_f(mapPlayerLocation_c)
                    }))

                obj_forEach_f(this.playerLocData_byUserId_o, (playerLocData_o, playerId_uid) => {
                    if(this.p_playersLocation_byUserId_c[playerId_uid] == null && (this.p_currentUserLocation_c == null || this.p_currentUserLocation_c.mpl_userId_uid !== playerId_uid)){

                        if(playerLocData_o.locationCircle_l){playerLocData_o.locationCircle_l.remove()}
                        if(playerLocData_o.accuracyCircle_l){playerLocData_o.accuracyCircle_l.remove()}
                        if(playerLocData_o.name_l){playerLocData_o.name_l.remove()}
                        delete this.playerLocData_byUserId_o[playerId_uid]

                    }
                })
            },
            m_getBounds_faan(riddlePosition_c,  rectangleSize_c){
                return [
                    [riddlePosition_c.mp_lat_n - (rectangleSize_c.mp_lat_n/2), riddlePosition_c.mp_lng_n - (rectangleSize_c.mp_lng_n/2)],
                    [riddlePosition_c.mp_lat_n + (rectangleSize_c.mp_lat_n/2), riddlePosition_c.mp_lng_n + (rectangleSize_c.mp_lng_n/2)]
                ]
            },
            m_getLocation_fan(riddlePosition_c, rectangleSize_c){
                return [
                    riddlePosition_c.mp_lat_n + (rectangleSize_c.mp_lat_n/2),
                    riddlePosition_c.mp_lng_n - (rectangleSize_c.mp_lng_n/2)
                ]
            },
            m_centerToUserLocation_f(){
                this.mymap_l.panTo(new L.LatLng(this.p_currentUserLocation_c.mpl_latitude_n, this.p_currentUserLocation_c.mpl_longitude_n), {animate: true, duration: 1});
            },
            m_polygonCenter_an(points_byIndex_c){



                let maxLat_n = points_byIndex_c[0].mp_lat_n
                let minLat_n = points_byIndex_c[0].mp_lat_n
                let maxLng_n = points_byIndex_c[0].mp_lng_n
                let minLng_n = points_byIndex_c[0].mp_lng_n

                obj_forEach_f(points_byIndex_c, point_c => {
                    if(maxLat_n < point_c.mp_lat_n){maxLat_n = point_c.mp_lat_n}
                    if(minLat_n > point_c.mp_lat_n){minLat_n = point_c.mp_lat_n}
                    if(maxLng_n < point_c.mp_lng_n){maxLng_n = point_c.mp_lng_n}
                    if(minLng_n > point_c.mp_lng_n){minLng_n = point_c.mp_lng_n}
                })


                return [(maxLat_n-minLat_n)/2+minLat_n , (maxLng_n-minLng_n)/2+minLng_n ]

            },
            m_clickMissionWrapper_f(index_n){
                switch(this.p_mapMissionType_e){
                    case enum_mapMissionsTypes.markers_route:
                        if(index_n > this.co_lastOpenRiddleIndex_n){
                            console.log("testol")
                            break;
                        }
                    case enum_mapMissionsTypes.squares_linear_groups_hide:
                    case enum_mapMissionsTypes.squares_linear_groups:
                    case enum_mapMissionsTypes.squares_linear:
                        if(!this.m_availableSquareRiddle_fb(index_n)){
                            notification_notify2({title_s: ass_strings.oneWord_locked[this.p_display_langCode_e]})
                            break;
                        }

                    default:
                        this.pe_onClickMission_f(index_n)
                }
            },
            m_availableSquareRiddle_fb(missionIndex_n){

                switch(this.p_mapMissionType_e) {
                    case enum_mapMissionsTypes.squares_linear_groups_hide:
                    case enum_mapMissionsTypes.squares_linear_groups:
                        let mission_c = this.p_missions_ac[missionIndex_n]
                        let missionGroup_c = this.m_getMissionsGroup_fc(mission_c)

                        let missionIndexInGroup_n = missionGroup_c.qbmg_riddlesIds_an.indexOf(mission_c.qbr_riddleId_n)

                        if(missionIndexInGroup_n === 0){
                            return true
                        }

                        let prevMissionId_n = missionGroup_c.qbmg_riddlesIds_an[missionIndexInGroup_n-1]
                        let PrevMissionIndexInGroup_n = this.co_missionsIndexes_byRiddleId_c[prevMissionId_n]

                        return this.m_finishMission_fb(PrevMissionIndexInGroup_n)
                    default:
                        return true
                }
            },
            m_finishMission_fb(missionIndex_n){
                return this.p_finishMissionsIndexes_an.includes(missionIndex_n)
            },

            m_getMissionsGroup_fc(mission_c){
                for(let groupIndex_n in this.p_missionGroups_ac) {

                    if(this.p_missionGroups_ac[groupIndex_n].qbmg_riddlesIds_an.includes(mission_c.qbr_riddleId_n)){
                        return this.p_missionGroups_ac[groupIndex_n]
                    }
                }
            },

            // helpers
            m_updatePlayerLocation_f(mapPlayerLocation_c){

                if(mapPlayerLocation_c == null){return}

                // init
                if(this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid] == null){

                    const leafletLoc_an = [mapPlayerLocation_c.mpl_latitude_n, mapPlayerLocation_c.mpl_longitude_n]
                    const color_s = mapPlayerLocation_c.cm_mpl_oldLocations_fb() ? "gray" : mapPlayerLocation_c.mpl_dotColor_s

                    this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid] = {
                        // 1) location circle
                        locationCircle_l :
                            L.circleMarker(leafletLoc_an, {
                                radius      : 8,
                                fill        : true,
                                color       : "white",
                                weight      : 1,
                                fillColor   : color_s,
                                fillOpacity : 1,
                                interactive : false
                            }).addTo(this.mymap_l),

                        // 2) accuracy circle
                        accuracyCircle_l : L.circle(
                            leafletLoc_an,
                            {
                                radius      : mapPlayerLocation_c.mpl_accuracy_n,
                                color       : color_s,
                                weight      : 1,
                                fillColor   : color_s,
                                interactive : false
                            })
                            .addTo(this.mymap_l),

                        // 3) username
                        name_l : mapPlayerLocation_c.mpl_username_s
                            ? L.marker(
                                leafletLoc_an,
                                {
                                    icon: L.divIcon({
                                        className: 'TQ_width_200px_important TQ_center TQ_text_bold TQ_text_14px',   // Set class for CSS styling
                                        html: mapPlayerLocation_c.mpl_username_s,
                                        iconAnchor: [100, 30],
                                    }),
                                })
                                .addTo(this.mymap_l)
                            : null,
                    }

                    // update
                }else{

                    // 1) update location
                    let current_latLng = this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].locationCircle_l.getLatLng()
                    let new_latLng = {lat: mapPlayerLocation_c.mpl_latitude_n, lng : mapPlayerLocation_c.mpl_longitude_n}

                    if( !obj_equals_fb(current_latLng, new_latLng)){
                        this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].locationCircle_l.setLatLng(new_latLng)
                        this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].accuracyCircle_l.setLatLng(new_latLng)
                        if(this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].name_l){
                            this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].name_l.setLatLng(new_latLng)
                        }
                    }

                    // 2) update color
                    const current_color_s = this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].locationCircle_l.options.fillColor
                    const new_color_s = mapPlayerLocation_c.cm_mpl_oldLocations_fb() ? "gray" : mapPlayerLocation_c.mpl_dotColor_s
                    if(current_color_s !== new_color_s){
                        this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].locationCircle_l.setStyle({fillColor : new_color_s})
                        this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].accuracyCircle_l.setStyle({fillColor : new_color_s, color: new_color_s})
                    }

                    // 3) update accuracy
                    const current_accuracy_n = this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].accuracyCircle_l.getRadius()
                    const new_accuracy_n = mapPlayerLocation_c.mpl_accuracy_n
                    if(current_accuracy_n !== new_accuracy_n){
                        this.playerLocData_byUserId_o[mapPlayerLocation_c.mpl_userId_uid].accuracyCircle_l.setRadius(new_accuracy_n)
                    }


                }

            },
        },
        watch:{

            p_polygons_ac:{
                handler(){
                    this.m_refreshPolygons_f()
                },
                deep: true,
            },
            p_finishMissionsIndexes_an:{
                handler(){
                    this.m_refresh_finishMissions_f()
                },
                deep: true,
            },
            p_currentUserLocation_c:{
                handler(){
                    this.m_updatePlayerLocation_f(this.p_currentUserLocation_c)
                },
                deep: true,
            },

        },
        activated() {
            if(this.mymap_l){
                this.mymap_l.invalidateSize(true);
            }
        },
        mounted(){
            // Code that will run only after the
            // entire view has been rendered

            this.$nextTick(() => {

                // 1) init map
                this.mymap_l = L.map(this.pb_mapUid_s, {

                    attributionControl : false,
                    gestureHandling    : this.pf_twoFingersMovement_b,
                    zoomControl        : this.p_showZoomControl_b
                })

                // two fingers support
                if(this.pf_twoFingersMovement_b){
                    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
                }

                // 2) settings
                this.mymap_l.keyboard.disable();

                this.mymap_l.setView([this.p_mapData_c.md_center_c.mp_lat_n, this.p_mapData_c.md_center_c.mp_lng_n], this.p_mapData_c.md_zoom_n);

                // set map
                if([enum_mapTypes.osm].includes(this.p_mapType_e)){

                    if(enum_langCodes.hebrew === this.p_display_langCode_e){
                        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 20,
                            minZoom: 4,
                        }).addTo(this.mymap_l);
                    }else{
                        let gl = L.mapboxGL({
                            style       : helper_getMapTilerStyle_f(this.p_display_langCode_e),
                        }).addTo(this.mymap_l);
                    }

                    // background
                }else{
                    L.tileLayer('', {
                        maxZoom: 20,
                        minZoom: 4,
                    }).addTo(this.mymap_l)

                    // background image
                    style_addNewStyle_f(`
                   .leaflet-container {
                        background-color: transparent;
                    }
                `)
                }

                if(this.p_rightZoomBtns_b){
                    // background image
                    style_addNewStyle_f(`
                        .leaflet-left{
                            left: auto;
                            right: 10px;
                        }
                    `)
                }

                // console.log(this.mymap_l.getBounds())

                // this.mymap_l.setMaxBounds(this.mymap_l.getBounds());

                // 4) draw polygons
                this.m_refreshPolygons_f()

                // 5) refresh overlayImages
                this.m_refreshOverlayImages_f()

                // 6) draw missions
                for(let missionIndex_n=0; missionIndex_n < this.p_missions_ac.length; missionIndex_n++){

                    let qb_mission_c = this.p_missions_ac[missionIndex_n]
                    let hideRectangle_b = [enum_mapMissionsTypes.squares_linear_groups_hide, enum_mapMissionsTypes.squares_hide].includes(this.p_mapMissionType_e)

                    switch (this.p_mapMissionType_e) {

                        case enum_mapMissionsTypes.markers:


                            this.m_drawMarker_f(missionIndex_n, qb_mission_c.qbr_riddlePosition_c, qb_mission_c.qbr_theme_c.qbrt_backgroundColor_s, null)
                            break;

                        case enum_mapMissionsTypes.squares_linear_groups_hide:
                        case enum_mapMissionsTypes.squares_linear_groups:

                            let missionGroup_c = this.m_getMissionsGroup_fc(qb_mission_c)
                            let missionIndexInGroup_n = missionGroup_c.qbmg_riddlesIds_an.indexOf(qb_mission_c.qbr_riddleId_n)
                            this.m_drawRectangle_fc(missionIndexInGroup_n, missionIndex_n, qb_mission_c.qbr_riddlePosition_c, qb_mission_c.qbr_rectangleSize_c, hideRectangle_b)

                            break;

                        case enum_mapMissionsTypes.squares_linear:
                        case enum_mapMissionsTypes.squares_hide:
                        case enum_mapMissionsTypes.squares:
                            this.m_drawRectangle_fc(missionIndex_n, missionIndex_n, qb_mission_c.qbr_riddlePosition_c, qb_mission_c.qbr_rectangleSize_c, hideRectangle_b)
                            break;

                        case enum_mapMissionsTypes.markers_route:

                            let markerColor_s = missionIndex_n <= this.co_lastOpenRiddleIndex_n ? (this.co_lastOpenRiddleIndex_n === missionIndex_n ? "#FF8C00" : "#501078") : "gray"

                            this.m_drawMarker_f(missionIndex_n, qb_mission_c.qbr_riddlePosition_c, markerColor_s, null)

                            if(missionIndex_n < this.p_missions_ac.length -1 ){
                                this.m_drawPath_f(qb_mission_c.qbr_riddlePosition_c, this.p_missions_ac[missionIndex_n+1].qbr_riddlePosition_c, qb_mission_c.qbr_pathToNextMission_ac)
                            }

                            break
                    }
                }

                // 6) refresh rectangle
                this.m_refresh_finishMissions_f()

                // 8) refresh locations
                date_doEveryClockTick_addCb_f(this.$options.name + this.pb_mapUid_s, () => {
                    this.m_refresh_playersLocations_f()
                    this.m_updatePlayerLocation_f(this.p_currentUserLocation_c)
                }, true)

            })

        },
        destroyed(){
            date_doEveryClockTick_removeCb_f(this.$options.name + this.pb_mapUid_s)
            if(this.mymap_l){
                this.mymap_l.off()
                this.mymap_l.remove()
            }
        }

    }
</script>

<style scoped>
    .leaflet-container {
        /*background-color: transparent;*/
        /*opacity: 0.5;*/
        /*!*background: #009edb*!*/
        /*-webkit-background-size: cover;*/
        /*-moz-background-size: cover;*/
        /*-o-background-size: cover;*/
        /*background-size: cover;*/
        /*background-image : url(https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/temp%2Fbg-screen01.jpeg?alt=media&token=14a4c298-aaac-4ca5-8024-aea38366e415)*/
    }
</style>